module.exports = __webpack_public_path__ + "static/media/water-animation.fece4c1a.gif";